import { createBrowserRouter } from 'react-router-dom';
import AdminLayout from './Admin';
import { Dashboard } from './components/Dashboard';
import { Pulse } from './components/Pulse';
import { PulseDetail } from './components/PulseDetail';
import { AppProvider } from './contexts';
import Auth from './pages/Auth';

export const router = createBrowserRouter([

    {
        path: '/',
        element: <AppProvider />,
        children: [
            {
                path: '/auth',
                element: <Auth />
            },
            {
                element: <AdminLayout />,
                children: [
                    {
                        index: true,
                        element: <Dashboard />
                    },
                    {
                        path: 'pulse',
                        element: <Pulse />
                    },
                    {
                        path: 'pulse/:pulseId',
                        element: <PulseDetail />
                    }
                ]
            }
        ]
    }
], {basename: '/admin'});